import { JSX } from 'preact';
import { EditorProps, ViewerProps, RichProp } from 'client/courses/components/page-builder';
import { ContainerWrapper } from 'client/courses/components/page-builder/container-wrapper';
import { CtaButton } from 'client/courses/components/page-builder/cta-button';
import { Color } from 'shared/colors';
import { CtaBlockState, PaddingSize } from 'server/types';

export const type = 'calendar-cta';
export const name = 'Call to Action';

export const initialState: CtaBlockState = {
  richText:
    '<h2>Ready to Get Started?</h2><p>Book your session today and take the first step towards achieving your goals.</p>',
  callToAction: {
    text: 'Book a Session',
    url: '/book-me',
  },
};

export const initialBlockState = {
  type,
  bgcolor: Color.gray800,
  fgcolor: Color.white,
  paddingt: 'md' as PaddingSize,
  paddingb: 'md' as PaddingSize,
};

export function MiniView(): JSX.Element {
  return (
    <span class="block py-4">
      <span class="w-4/6 mx-auto block text-center">
        <span class="block bg-gray-500 opacity-75 rounded-sm h-2 mb-2 mx-auto w-2/3"></span>
        <span class="block bg-gray-400 opacity-75 rounded-sm h-1 mb-3 mx-auto w-4/5"></span>
        <span class="bg-gray-600 opacity-75 rounded h-2 w-2/5 mx-auto block"></span>
      </span>
    </span>
  );
}

function View(props: EditorProps<CtaBlockState> | ViewerProps<CtaBlockState>): JSX.Element {
  return (
    <ContainerWrapper class="text-center">
      <div class="max-w-4xl mx-auto">
        <div class="@lg:mb-8 @sm:mb-6 mb-4">
          <RichProp {...props} path="richText" class="text-center" />
        </div>

        <div class="flex justify-center">
          <CtaButton {...props} path="callToAction" />
        </div>
      </div>
    </ContainerWrapper>
  );
}

export const Editor = View;
export const Viewer = View;
